(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name trackingDiscrepancy.controller:TrackingDiscrepancyCtrl
   *
   * @description
   *
   */
  angular
    .module('trackingDiscrepancy')
    .controller('TrackingDiscrepancyCtrl', TrackingDiscrepancyCtrl);

  function TrackingDiscrepancyCtrl(CommonMasterData, trackingDiscrepancyService, applicationConstants, MessageService) {
    var vm = this;
    vm.ctrlName = 'TrackingDiscrepancyCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      isElasticLoadingVisible: false,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        startTime: null,
        endTime: null,
        crewType: null,
        aircraftType: null,
        crewBase: null,
        days: null,
        flightCategory: null,
        flightStatus: null,
        patternType: [],
        acmiProvider: null,
        distributionGroupsList: null,
        condition: false
      },
      masterList: {
        commonCriteriaList: [],
        crewTypeList: [],
        crewBaseList: [],
        aircraftTypes: [],
        flightStatusList: [],
        acmiProviderList: [],
        patternTypeList : [{type:"FLIGHT"},{type:"EVENT"},{type:"TRAINING"},{type:"OFFICE"},{type:"DEADHEAD"},{type:"OBSERVER"},{type:"STANDBY"}],
        patternTypeOptions: {
          sortBy: 'type',
          uniqueField: 'type'
        },
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        startTimeFormatInvalid: false,
        endTimeFormatInvalid:false,
        fromDateAfterToDate: false,
        distributionGroups: [],
      },
      trackingDiscrepancyList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.flightCategoryList = {
      ALL : 'All',
      StandByOnly : 'Stand By Only',
      FlightsOnly : 'Flights Only'
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;


    vm.submitSearch = function (params) {
      params.condition = vm.model.searchCriteria.condition;
      trackingDiscrepancyService.searchTrackingDiscrepancy(params,
        function (response) {
        vm.model.trackingDiscrepancyList = response.trackingDiscrepancyDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.trackingDiscrepancyDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.trackingDiscrepancyList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          PATTERN_NAME: vm.model.trackingDiscrepancyList[i].pattrenName,
          CREW_ASSIGED: vm.model.trackingDiscrepancyList[i].noOfCrewAssiged,
          CREW_REQUIRED: vm.model.trackingDiscrepancyList[i].noOfCrewRequierd,
          STARTD_DATE_TIME: vm.model.trackingDiscrepancyList[i].startDate,
          TYPE: vm.model.trackingDiscrepancyList[i].type,
          TRAINER: vm.model.trackingDiscrepancyList[i].trainer,
          TRAINEE: vm.model.trackingDiscrepancyList[i].trainee,

        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        contextMenu:true,
        copyRowsLimit: 1000000,

        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'PATTERN_NAME',
            type: 'text',
            readOnly: true
          },{
            data: 'TYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'STARTD_DATE_TIME',
            type: 'text',
            readOnly: true
          }, {
            data: 'CREW_REQUIRED',
            type: 'text',
            readOnly: true
          }, {
            data: 'CREW_ASSIGED',
            type: 'text',
            readOnly: true
          }, {
            data: 'TRAINER',
            type: 'text',
            readOnly: true
          },{
            data: 'TRAINEE',
            type: 'text',
            readOnly: true
          }],
        colWidths: [4, 16, 10, 10, 7, 7, 7,7],
        stretchH: 'all',
        width: 1260,
        autoWrapRow: true,
        height: 780,
        rowHeaders: true,
        colHeaders: [
          '',
          'Pairing Name',
          'Type',
          'Start Date(UTC)',
          'Crew Required',
          'Crew Assigned',
          'Trainer',
          'Trainee'

        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');

    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      setTimeValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if (flag != 'days') {
        if ((searchParams.fromDate != null && searchParams.toDate != null && searchParams.days == null)
          || (searchParams.fromDate != null && searchParams.toDate != null && (flag == 'toDate' || flag == 'fromDate'))) {
          vm.model.searchCriteria.days = calculateNoOfDays();
        }
      }

      if (flag === 'days' && searchParams.fromDate != null) {
        vm.model.searchCriteria.toDate = moment(searchParams.fromDate, "DD/MM/YYYY").add(searchParams.days, 'days').format("DD/MM/YYYY");

      }

      if (flag === 'startTime' && searchParams.startTime != null) {
         vm.model.searchCriteria.startTime = searchParams.startTime;
      }

      if (flag === 'endTime' && searchParams.endTime != null) {
               vm.model.searchCriteria.endTime = searchParams.endTime;
      }

      if (flag === 'days' && searchParams.toDate != null && searchParams.fromDate == null) {
        vm.model.searchCriteria.fromDate = moment(searchParams.toDate, "DD/MM/YYYY").subtract(searchParams.days, 'days').format("DD/MM/YYYY");
      }

      if (flag === 'fromDate' && searchParams.toDate == null && searchParams.fromDate !=null) {
        var moEnd = moment(vm.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT).endOf("month");
        vm.model.searchCriteria.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
        vm.model.searchCriteria.days = calculateNoOfDays();

      }

    };


    function calculateNoOfDays() {
      vm.cal_start = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY");
      vm.cal_end = moment(vm.model.searchCriteria.toDate, 'DD/MM/YYYY');
      return vm.cal_end.diff(vm.cal_start, 'days') + 1;
    };


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function setTimeValidationFlags() {
      if (isTimeFormatInvalid(vm.model.searchCriteria.startTime)) {
        vm.model.masterList.startTimeFormatInvalid = true;
      } else {
        vm.model.masterList.startTimeFormatInvalid = false;
      }
      if (isTimeFormatInvalid(vm.model.searchCriteria.endTime)) {
        vm.model.masterList.endTimeFormatInvalid = true;
      } else {
        vm.model.masterList.endTimeFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function isTimeFormatInvalid(time) {
      if (!!time && !moment(time, "HH:mm").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    function isEndTimeBeforeStartTime() {
      const endTime = moment(vm.model.searchCriteria.endTime, "HH:mm");
      const startTime = moment(vm.model.searchCriteria.startTime, "HH:mm");
      return endTime.isBefore(startTime);
    }

    (function () {
      // crew type master codes
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

      CommonMasterData.getCrewBaseList(function (baseTypes) {
          vm.model.masterList.crewBaseList = baseTypes;
        },
        function () {
          console.log('Crew Base type retrieval error');
        });

      CommonMasterData.getAircraftModels(function (airCraftList) {
        vm.model.masterList.aircraftTypes = airCraftList;
      }, function () {
        console.log('Aircraft type retrieval error');
      });

      CommonMasterData.getFlightStatusList(function(flightStatusList) {
        vm.model.masterList.flightStatusList = flightStatusList;
      }, function(error) {
        console.log('Flight Status List retrieval error!!!');
      });

      CommonMasterData.getACMITypesList(function(acmiProviderList) {
        vm.model.masterList.acmiProviderList = acmiProviderList;
      }, function(error) {
        console.log('ACMI Provider List retrieval error!!!');
      });

      trackingDiscrepancyService.searchActiveDistributionConfigIdentifiers(function (response) {
        const activeDistributionIdentifierList = response.activeDistributionIdentifierList;
        const distributionGroups = [];
        angular.forEach(activeDistributionIdentifierList, function(activeDistributionIdentifier) {
          var distributionGroup = {
            distributionGroupDescription: activeDistributionIdentifier,
            distributionGroupCode: activeDistributionIdentifier
          };
          distributionGroups.push(distributionGroup);
        });
        vm.model.masterList.distributionGroups = distributionGroups;
      }, function (error) {
        console.log('Active Distribution Config Identifiers List retrieval error!', error.msg[0]);
      });

    })();


  }
}());
